/**
 * References section
 */
(function referencesFrontend($) {
    $(document).on('cms.ready', ready);

    let $section,
        referenceLogos = [];

    const observerOptions = {
        root: null, // relative to document viewport
        rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: .9 // visible amount of item shown in relation to root
    };


    /* Initial building of the ServiceCases */
    function ready() {
        $section = $('.sectionReferences');

        loadReferenceLogos(observeLogos);
    }

    function loadReferenceLogos(callback) {
        // only get them once
        if (referenceLogos.length > 0) {
            callback();
            return;
        }

        $.get(
            'api/customerlogo/list',
            { limit: 100, order: '-id' },
            function processReferences(data) {
                referenceLogos = data.rows;
                insertReferenceLogosIntoDOM();
                callback();
            }
        );
    }

    function observeLogos() {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                // console.log(entry);
                if(entry.isIntersecting) {
                    // console.log(entry.target);
                    $(entry.target).addClass('fadeInUp');
                }
                else {
                    $(entry.target).removeClass('fadeInUp');
                }
            });
        }, observerOptions);

        $('.sectionReferences__logo', $section).each((idx, elm) => observer.observe(elm));
    }

    function insertReferenceLogosIntoDOM() {
        for (let key in referenceLogos) {
            let rl = referenceLogos[key];

            // skip references with no logo
            if (!rl.logoImageUrl) continue;

            // create DOM element and insert into template
            let $logo = $('<div class="sectionReferences__logo"></div>')
            let $img = $('<img alt="'+ rl.name +'" src="'+ rl.logoImageUrl +'" loading="lazy" width="112" height="24" />');
            $logo.append($img);
            $('.sectionReferences__logos', $section).append($logo);
        }
    }

})(jQuery, window);